import React from 'react';
export function TrustBar() {
  return;
}